<template>
	<div class="header">
		<div class="mobile-navbar-wrapper">
			<div class="navbar" @click="clickHandler">
				<div class="navbar-icons">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
		</div>
		<div class="logo">
			<img src="../assets/img/logo.png" alt="">
		</div>
		<ul class="nav" v-show="menuIsShow">
			<li>
				<router-link to="/">Publishing</router-link>
			</li>
			<li>
				<router-link to="/games">Games</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import Device from '../assets/js/device.js';

	export default {
		name: 'Header',

		data: () => ({
			mobile: {
				navbar: false
			}
		}),

		computed: {
			menuIsShow() {
				const { isMobile } = this;
				if( isMobile ){
					return this.mobile.navbar;
				}else{
					return true;
				}
			},
			isMobile() {
				return window.device && window.device.mobile();
			},
		},

		methods: {
			clickHandler(){
				this.mobile.navbar = !this.mobile.navbar;
			}
		}
	}
</script>

<style lang="less" scoped>
	.mobile {
		.header {
			.mobile-navbar-wrapper {
				display: block;
				z-index: 1020;
			}
			.logo {
				position: absolute;
			    top: 55%;
			    left: 50%;
			    transform: translate3d(-50%, -50%, 0);
			    text-align: center;
			    img {
			    	display: inline-block;
			    }
			}
			.nav {
				position: fixed;
				width: 100%;
				background-color: #ffffff;
				top: 0;
				left: 0;
			    padding-top: 44px;
			    padding-bottom: 44px;
				z-index: 1002;
				// transform: translateY(-100%);

				li {
					display: block;
				    padding: 0 24px;
				    position: relative;
				    z-index: 1015;

				    a {
				    	border-bottom: 1px solid #eee;
			    	    color: #666;
			    	    display: block;
			    	    font-size: 16px;
			    	    font-weight: 300;
			    	    padding: 15px 30px;
				    }
				}
			}

			.content {
				.section-1 {
					img {
						height: 100%;
						width: auto;
					}
				}
				
			}
		}
	}
	.header {
		position: absolute;
		top: 0;
		display: table;
		width: 100%;
		padding: 32px 40px 24px;
		z-index: 1;
		
		.mobile-navbar-wrapper {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			padding: 10px;
			display: none;

			.navbar {
				background: #888;
				box-shadow: 0 1px 3px 0 rgba(0,0,0,.3);
				color: #fff;
				transition: all .3s ease-out;
				border-radius: 3px;
				cursor: pointer;
			    display: block;
			    height: 40px;
	  			outline-style: none;
		        pointer-events: all;
		        position: relative;
		        text-align: center;
		        width: 40px;
		        z-index: 1020;
		        line-height: 48px;

				.navbar-icons {
					display: inline-block;
					cursor: pointer;
				    height: 17.3px;
				    position: relative;
				    transform: rotate(0deg);
				    transition: .5s ease-in-out;
				    width: 22px;

				    span {
				    	background-color: #fff;
			    	    border-radius: 2px;
			    	    display: block;
			    	    height: 2px;
			    	    left: 0;
			    	    opacity: 1;
			    	    position: absolute;
			    	    transform: rotate(0deg);
			    	    transition: .25s ease-in-out;
			    	    width: 100%;
				    }

				    span:first-child {
			    	    top: 0;
			    	    transform-origin: left center;
				    }

				    span:nth-child(2) {
			    	    top: 6px;
			    	    transform-origin: left center;
				    }

				    span:nth-child(3) {
			    	    top: 12px;
			    	    transform-origin: left center;
				    }
				}
			}
		}
		
		
		.logo {
			display: table-cell;
			vertical-align: middle;
			padding: 8px 0;
			width: 220px;
			height: 66px;
			overflow: hidden;
			img {
				display: block;
				height: 100%;
			}
		}
		.nav {
			display: table-cell;
			vertical-align: middle;
			text-align: right;
			font-size: 16px;
			font-weight: 600;
			
			li {
				display: inline-block;
				margin: 0 10px;
				a {
					cursor: pointer;
					color: #ffffff;
				}
			}
		}
	}
</style>